import { createSlice } from "@reduxjs/toolkit";
import { getPropertiesEntry, getPropertiesTemplateService } from "../requests";
import { qrTextInitialState } from "../../constants/common";

const qrText = createSlice({
  name: "qrSettings",
  initialState: qrTextInitialState,
  reducers: {
    qrFrameText(state, { payload }) {
      state.frameText = payload;
    },
    qrDraggableText(state, { payload }) {
      state.draggableText = payload;
    },
    qrFontFamily(state, { payload }) {
      state.fontFamily = payload;
    },
    qrFontWeight(state, { payload }) {
      state.fontWeight = payload;
    },
    qrSetText(state, { payload }) {
      return payload;
    },
    qrTextSize(state, { payload }) {
      state.textSize = payload;
    },
    qrResetText() {
      return qrTextInitialState;
    },
  },
  extraReducers: {
    [getPropertiesEntry.fulfilled]: (state, { payload }) => {
      if (payload.data.qrText) {
        state.frameText = payload.data.qrText.frameText;
        state.textSize =
          payload.data.qrText.textSize || qrTextInitialState.textSize;
      }
    },
    [getPropertiesTemplateService.fulfilled]: (state, { payload }) => {
      if (payload.data.qrText) {
        state.frameText = payload.data.qrText.frameText;
        state.textSize =
          payload.data.qrText.textSize || qrTextInitialState.textSize;
      }
    },
  },
});
export const {
  qrFrameText,
  qrDraggableText,
  qrFontFamily,
  qrFontWeight,
  qrSetText,
  qrResetText,
  qrTextSize,
} = qrText.actions;
export default qrText.reducer;
